import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  Hidden,
  TextField,
  Typography,
} from "@mui/material";
import swal from "sweetalert";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import _ from "lodash";
// import * as swal from 'sweetalert';
import Swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import overlayFactory from "react-bootstrap-table2-overlay";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function ShowSubCategory() {
  const [loading, setLoading] = useState(true);
  const [productlist, setproductlist] = useState([]);

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
  });

  useEffect(() => {
    axios.get(`api/show_subcategory`).then((res) => {
      if (res.status === 200) {
        setproductlist(res.data.subcategory);
      }
      setLoading(false);
    });
  }, []);

  function add3Dots(string, limit) {
    var dots = "...";
    if (string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }

  const deleteUser = (e, id) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data= {user_id:userId,};

    const thisClicked = e.currentTarget;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure , you want to delete this customer",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#D10000",
        cancelButtonColor: "#00D100",
        confirmButtonText: "Yes,delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          axios.post(`api/delete_subcategory/${id}`,data).then((res) => {
            if (res.data.status === 200) {
              thisClicked.closest("tr").remove();
            } else if (res.data.status === 404) {
              swal("Success", res.data.message, "success");
              thisClicked.innerText = "Delete";
            }
          });
          swalWithBootstrapButtons.fire(
            "Deleted!",
            "subcategory deleted successfully.",
            "success"
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          // swalWithBootstrapButtons.fire(
          //   'Cancelled',
          //   'Your imaginary file is safe :)',
          //   'error'
          // )
        }
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "4",
        value: 4,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: productlist.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  var add = add3Dots("address", 25);
  const ans = add3Dots("address", 25);

  const columns = [
    {
      dataField: "id",
      text: "ID",
    },
    {
      dataField: "category",
      text: "Category",
    },
    {
      dataField: "subname",
      text: "SubCategory",
    },
  

    {
      dataField: "action",
      text: "Actions",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        console.log(row);
        const productId = row.id;
        return (
          <ThemeProvider theme={theme}>
            <Grid container spacing={2}>
              <Grid item xs={1}>
                <Button
                  component={Link}
                  to={`/certificates/view_subcategory/${productId}`}
                  color="apple"
                  size="medium"
                  startIcon={<VisibilityIcon color="inherit" />}
                />
              </Grid>
              <Grid item xs={1}>
                <Button
                  component={Link}
                  to={`/certificates/edit_subcategory/${productId}`}
                  color="apple"
                  size="medium"
                  startIcon={<EditIcon color="inherit" />}
                />
                {/* <td><Link to={`edit-customer/${item.id}`} className="btn btn-success btn-sm">Edit</Link></td> */}
                {/* <td><button type="button" onClick={(e) => deleteUser(e, item.id)} className="btn btn-danger bt-sm">Delete</button></td> */}
              </Grid>
              <Grid item xs={1}>
                <Button
                  onClick={(e) => deleteUser(e, productId)}
                  color="error"
                  size="medium"
                  startIcon={<DeleteIcon color="error" />}
                />
              </Grid>
            </Grid>
          </ThemeProvider>
        );
      },
    },
  ];

  return (
    <div>
      <Navbar />
      <div className="card px-8 m-5">
        <div className="card-header">
          <div class="d-flex justify-content-between">
            <h4>
              Sub Category Master
              {/* <Link to="/add_subcategory" className='btn btn-primary btn-bg float-end'>Add Sub Category</Link> */}
            </h4>
            <ThemeProvider theme={theme}>
              <Button
                component={Link}
                to="/certificates/add_subcategory"
                variant="contained"
                color="apple"
              >
                Add SubCategory
              </Button>
            </ThemeProvider>
          </div>
        </div>
        <BootstrapTable
          keyField="id"
          data={productlist}
          columns={columns}
          hover
          condensed
          // pagination={paginationFactory(options)}
          filter={filterFactory()}
          overlay={overlayFactory()}
        />
      </div>
    </div>
  );
}

export default ShowSubCategory;
